import { render, staticRenderFns } from "./AvailabilityStatus.vue?vue&type=template&id=615cfd4e&scoped=true"
import script from "./AvailabilityStatus.vue?vue&type=script&lang=js"
export * from "./AvailabilityStatus.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityStatus.vue?vue&type=style&index=0&id=615cfd4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615cfd4e",
  null
  
)

export default component.exports